import React from "react";
import { useNavigate } from "react-router-dom";

const ViewFilesButton = ({ file }) => {
  const navigate = useNavigate();
  return (

    <button
      className="btn btn-outline-secondary btn-sm me-0 rounded-pill"
      title="View Files"
      onClick={() => navigate(`/scorm-explorer/${file.id}`)}
    >
      <i className="bi bi-box-arrow-right"></i>
    </button>
  )
};

export default ViewFilesButton; 